import { routes as menus } from '@/router'

// console.log('%c%s', 'color:green', JSON.stringify(menus))
const state = {
  menus: menus
}

const mutations = {
  SET_MENUS: (state, menus) => {
    state.menus = menus
  }
}

const actions = {
  setMenus ({ commit }, menus) {
    commit('SET_MENUS', menus)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
